const filteringCondition = (data, filterType) => {
    if ('state' in data) return data.state.toLowerCase().includes(filterType);
    else return data;
}

export default filteringCondition;